<template>
  <el-dialog
    title="修改打印配置"
    :visible.sync="dialogVisible"
    width="50%"
    @close="resetForm"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="100px"
      label-position="right"
    >
      <el-form-item label="规格" prop="specCd">
        <el-select
          v-model="formData.specCd"
          placeholder="请选择规格"
          style="width:100%"
        >
          <el-option
            label="催缴打印说明"
            value="1010"
          ></el-option>
          <el-option
            label="收据打印"
            value="2020"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="名称" prop="printName">
        <el-input
          v-model="formData.printName"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>

      <el-form-item label="图片" prop="qrImg">
        <upload-image
          ref="uploadImage"
          :image-count="1"
          :default-images="[formData.qrImg]"
          @change="handleImageChange"
        ></upload-image>
      </el-form-item>

      <el-form-item label="内容" prop="content">
        <el-input
          v-model="formData.content"
          type="textarea"
          :rows="5"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateFeePrintSpec } from '@/api/goods/feePrintSpecApi'
import { getShopId } from '@/api/shop/shopApi'
import UploadImage from '@/components/system/UploadImage'
export default {
  name: 'EditFeePrintSpec',
  components: {
    UploadImage
  },
  data() {
    return {
      dialogVisible: false,
      formData: {
        printId: '',
        specCd: '',
        printName: '',
        qrImg: '',
        content: '',
        shopId: ''
      },
      rules: {
        specCd: [
          { required: true, message: '请选择规格', trigger: 'change' }
        ],
        printName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { max: 128, message: '长度不能超过128个字符', trigger: 'blur' }
        ],
        qrImg: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' },
          { max: 1000, message: '长度不能超过1000个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.formData = {
        ...data,
        shopId: getShopId()
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.uploadImage && this.$refs.uploadImage.setImages([data.qrImg])
      })
    },
    handleImageChange(images) {
      this.formData.qrImg = images.length > 0 ? images[0] : ''
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          await updateFeePrintSpec(this.formData)
          this.$message.success('修改成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error(error)
          this.$message.error(error.message || '修改失败')
        }
      })
    },
    resetForm() {
      this.formData = {
        printId: '',
        specCd: '',
        printName: '',
        qrImg: '',
        content: '',
        shopId: ''
      }
    }
  }
}
</script>